<template>
  <div class="center-screen">
    <div class="graphic"></div>
    <div class="container">
      <div class="four-oh-four"><h1>{{$t("401.message_1")}}</h1></div>

      <div class="warning">
        <h2>{{$t("401.message_2")}}</h2>
        <p>{{$t("401.message_3")}}</p>
        <a
          href="https://whatthefork.co.uk"
          target="_blank"
          class="nav-link"
        ></a>
      </div>

      <!-- /.container -->
    </div>
  </div>
</template>
<script>
export default {
  bodyClass: "error-page"
};
</script>
<style scoped>
.container {
  max-width: 400px;
  _width: 400px;
  /*margin: 0 auto 80px;*/
  text-align: center;
}

h1 {
  font-size: 2rem;
  margin: 0;
}

h2 {
  font-size: 0.8rem;
  font-weight: 400;
  margin: 0;
  padding: 4px 0 10px;
  color: #aaa;
}

h3 {
  margin: 20px 0 8px;
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  line-height: 1.4;
  padding: 0 30px;
}

.warning {
  margin: 0px 0 30px 0;
  padding: 0px 20px 8px;
}
.warning p {
  font-size: 1.5rem;
}

.warning a {
  display: block;
  background: no-repeat center center url("/img/wtf-button.svg");
  height: 70px;
}
.graphic {
  max-width: 100%;
  height: 400px;
  margin: 0 20px;
  background: no-repeat center center url("/img/401-graphic.svg");
}

.four-oh-four {
  padding-top: 20px;
  margin: auto;
}

/* Responsive
-------------------------------------------------------*/

/* Desktop only */
@media only screen and (min-width: 1800px) {
  h2 {
    font-size: 28px;
    font-size: 1.75rem;
  }
  .warning p {
    font-size: 14px;
    font-size: 0.88rem;
  }
  .graphic {
    max-width: 100%;
    height: 400px;
  }
}

@media only screen and (max-width: 375px) {
  .graphic {
    height: 240px;
  }
  .four-oh-four {
    margin: 10px auto 10px;
  }
  h2 {
    font-size: 0.88rem;
    font-weight: bold;
  }
  .warning {
    margin: 0;
  }
  .warning p {
    margin-top: 10px;
    font-size: 0.63rem;
  }
}
</style>
